/* eslint-disable */
import axios from "axios";

const url = process.env.REACT_APP_DOMINA_URL;
let result;

export const SUSCCES = "success";
export const ERROR = "error";

export async function RegistrarResolucionesDomina(body, setLoading, token) {
  setLoading(true);
  var headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };
  await axios
    .get(`${url}RegistrarResoluciones/${body}`, {
      mode: "no-cors",
      headers: headers,
    })
    .then((res) => {
      result = { data: res.data, status: res.status };
      setLoading(false);
    })
    .catch((err) => {
      if (err.response) {
        result = { data: err.response.data, status: err.response.status };
      } else if (err.request) {
        result = { data: err.message, status: err.request.status };
      } else {
        result = { data: err.message, status: 0 };
      }
      setLoading(false);
    });
  return result;
}
